<template>
  <div class="articles">
    <div class="articles-box">
      <div class="articles-header">办事指南</div>
      <div class="articles-box-content" v-if="caseList.length > 0">
        <div
          class="articles-box-one"
          v-for="(item,index) in caseList"
          :key="index"
          @click="toDetail(item)"
        >
          <div class="articles-text-left">{{item.title}}</div>
          <div class="articles-text-right">{{item.orgName}}</div>
        </div>
        <div class="page-box">
          <el-pagination
            background
            @current-change="handleSizeChange"
            :current-page.sync="pageNo"
            :page-size="pageSize"
            layout="prev, pager, next, jumper"
            :total="total"
          ></el-pagination>
        </div>
      </div>
      <div style="height:80%" v-else>
        <None />
      </div>
    </div>
  </div>
</template>
<script>
import { queryGuidePage } from '@/api/publicinquiry.api.js';
import { setSession, getSession } from '@/untils';
import None from '@/components/none.vue';
export default {
  components: {
    None
  },
  data() {
    return {
      caseList: [],
      total: 0,
      pageNo: 1,
      pageSize: 5,
      orgId: ''
    };
  },
  methods: {
    handleSizeChange(page) {
      this.pageNo = page;
      this.getList();
    },
    getList() {
      let params = {
        pageNo: this.pageNo,
        pageSize: this.pageSize,
        orgId: this.orgId,
        isPublic: '1'
      };
      queryGuidePage(params).then(res => {
        if (res.body) {
          this.total = res.body.total;
          this.caseList = res.body.records;
        }
      });
    },
    toDetail(item) {
      setSession('id', item.id);
      this.$router.push({ name: 'articlesDetail' });
    }
  },
  created() {
    this.orgId = getSession('orgId');
    this.getList();
  }
};
</script>
<style>
.articles {
  height: 100%;
  /* overflow: auto; */
}
.articles-box {
  height: 100%;
  background: #ffffff;
}
.articles-header {
  padding: 5px 0px;
  width: 100%;
  color: rgb(2, 91, 145);
  text-indent: 15px;
  border-bottom: 2px solid rgb(2, 91, 145);
  font-size: 20px;
  font-weight: 700;
}
.articles-box-content {
  padding: 0px 10px;
  overflow: auto;
  height: calc(100% - 53px);
}
.articles-box-one {
  cursor: pointer;
  margin-top: 20px;
  height: 70px;
  background: rgb(224, 245, 255);
}
.articles-text-left {
  width: 69%;
  padding: 10px;
  font-size: 16px;
  word-break: break-all;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 1;
  overflow: hidden;
  height: 15px;
}
.articles-text-right {
  text-align: right;
  padding-right: 10px;
}
.articles-box-one:hover .articles-text-left {
  color: #025b91;
}
.articles-box-one:hover {
  background: rgb(253, 245, 230);
}
.page-box {
  text-align: right;
  margin-top: 30px;
  padding-bottom: 30px;
}
.page-box .el-pagination.is-background .el-pager li:not(.disabled).active {
  background-color: #025b91 !important;
  color: #fff !important;
}
</style>
<style media="screen">
/*分辨率低于1440，采用下面的样式*/
@media screen and (max-device-height: 960px) {
  .articles-box-one {
    margin-top: 20px !important;
    height: 40px !important;
    line-height: 20px !important;
    padding: 10px;
  }
  .articles-text-left {
    padding: 5px !important;
  }
}
</style>


// WEBPACK FOOTER //
// src/page/articles/index.vue